import { ContactProjectSummary, formatShortDate, projectStatusLabel } from '../utils/contactBuilder';

type DscvryMemberRequestsProps = {
  projects: ContactProjectSummary[]
  loading?: boolean
  onOpen: (projectId: string) => void
};

/** Expert Requests for DSCVRY: one row per member contact list. */
const DscvryMemberRequests = ({ projects, loading = false, onOpen }: DscvryMemberRequestsProps) => (
  <div className="mx-auto my-4 w-11/12 rounded-2xl border border-[#E4EEF1] bg-white p-6 font-open-sans text-sm" data-testid="dscvry-member-requests">
    <p className="page-kicker">Expert requests</p>
    <h2 className="mt-1 font-raleway text-lg font-semibold text-ink">Member contact lists</h2>
    <p className="mt-1 text-[#4D4D4D]">Each row is a list a member generated for one pantry business. Open a row to review it and hand it to DSCVRY.</p>
    <div className="mt-4 overflow-x-auto rounded-lg border border-[#E4EEF1]">
      <table className="min-w-full text-left text-sm">
        <thead className="bg-[#F6FAFB] text-xs text-[#4D4D4D]">
          <tr>
            <th className="px-3 py-2 font-semibold">Business</th>
            <th className="px-3 py-2 font-semibold">Rows</th>
            <th className="px-3 py-2 font-semibold">Needs review</th>
            <th className="px-3 py-2 font-semibold">Last generated</th>
            <th className="px-3 py-2 font-semibold">Status</th>
          </tr>
        </thead>
        <tbody>
          {projects.map((item) => (
            <tr
              key={item.project_id}
              className="cursor-pointer border-t border-[#E4EEF1] hover:bg-[#F6FAFB]"
              onClick={() => onOpen(item.project_id)}
              data-testid={`member-request-${item.project_id}`}
            >
              <td className="px-3 py-2 font-raleway font-semibold text-ink">{item.name || 'Contact research'}</td>
              <td className="px-3 py-2">{item.record_count}</td>
              <td className="px-3 py-2">{item.review_count}</td>
              <td className="px-3 py-2">{formatShortDate(item.last_generated)}</td>
              <td className="px-3 py-2">{projectStatusLabel(item)}</td>
            </tr>
          ))}
          {projects.length === 0 && (
            <tr>
              <td className="px-3 py-3 text-[#4D4D4D]" colSpan={5}>{loading ? 'Loading member lists.' : 'No member has generated a list yet.'}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default DscvryMemberRequests;
